<div class="down-footer__main">
  <a class="down-footer__logo" routerLink="/">
    <img
      src="assets/symbol.svg"
      width="38"
      height="38"
      alt="imagebase.pro logo"
    />
    <span>image<b>base</b></span>
  </a>
  <div class="down-footer__links">
    <a
      href="https://find-and-update.company-information.service.gov.uk/company/15914437"
      target="_blank"
    >
      &copy; 2025 <span>—</span> DIGITAL DP LTD <span>—</span> 15914437
    </a>
    <a routerLink="/terms-of-use">Terms of Use</a>
  </div>
</div>
